import authService from '@/services/auth';
import { LOGIN } from '@/constants/routes';

export default function checkAuth() {
  const hasAuthTokens = authService.hasAuthTokens();
  if (hasAuthTokens) return true;
  return { name: LOGIN };
}
